// extracted by mini-css-extract-plugin
export var container = "_74-0";
export var infoButton = "_74-1";
export var label = "_74-3";
export var labelExpanded = "_74-4";
export var price = "_74-5";
export var priceExpanded = "_74-6";
export var title = "_74-2";